import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import 'isomorphic-fetch';
import queryString from 'query-string';
var OUTCOME_QUERY_DEPTH = 2;
var checkResponse = function checkResponse(response) {
  if (!response.ok) {
    throw response;
  }
  return response;
};
var toJson = function toJson(response) {
  return response.json();
};
var getTotal = function getTotal(response) {
  var total = response.headers.get('total');
  return total ? Number.parseInt(total) : 0;
};
var SUB_ACCOUNT_OUTCOME = 'SUB_ACCOUNT_OUTCOME';
var NOT_IN_SUB_ACCOUNT = 'NOT_IN_SUB_ACCOUNT';
var COURSE_OUTCOME = 'COURSE_OUTCOME';
var NOT_IN_COURSE = 'NOT_IN_COURSE';
var HIDE = 'HIDE';
var DECORATOR_SORT_ORDER = {
  null: 0,
  undefined: 0,
  SUB_ACCOUNT_OUTCOME: 1,
  NOT_IN_SUB_ACCOUNT: 2,
  COURSE_OUTCOME: 3,
  NOT_IN_COURSE: 4,
  HIDE: 5
};
var byDecorator = function byDecorator(o1, o2) {
  var d1 = DECORATOR_SORT_ORDER[o1.decorator];
  var d2 = DECORATOR_SORT_ORDER[o2.decorator];
  if (d1 < d2) {
    return -1;
  } else if (d1 > d2) {
    return 1;
  }
  return 0;
};

/* eslint-disable no-param-reassign */
var decorateAlignments = function decorateAlignments(alignmentSet, launchContext, isLaunchingFromRootAccount) {
  var outcomes = alignmentSet.outcomes;
  if (!launchContext || !outcomes) {
    return alignmentSet;
  }
  outcomes.forEach(function (outcome) {
    if (isLaunchingFromRootAccount) {
      // No need to decorate if outcome is in root account
      if (!outcome.in_launch_context) {
        var _outcome$source_conte;
        switch ((_outcome$source_conte = outcome.source_context_info) === null || _outcome$source_conte === void 0 ? void 0 : _outcome$source_conte.context_type) {
          case 'course':
            outcome.decorator = COURSE_OUTCOME;
            break;
          case 'account':
            outcome.decorator = SUB_ACCOUNT_OUTCOME;
            break;
        }
      }
    } else if (outcome.launch_context_type === 'account') {
      // No need to decorate if outcome is in the sub-account
      if (!outcome.in_launch_context) {
        var _outcome$source_conte2;
        switch ((_outcome$source_conte2 = outcome.source_context_info) === null || _outcome$source_conte2 === void 0 ? void 0 : _outcome$source_conte2.context_type) {
          case 'course':
            outcome.decorator = COURSE_OUTCOME;
            break;
          case 'account':
            outcome.decorator = NOT_IN_SUB_ACCOUNT;
            break;
        }
      }
    } else if (outcome.launch_context_type === 'course') {
      // No need to decorate if outcome is in the course
      if (!outcome.in_launch_context) {
        var _outcome$source_conte3;
        switch ((_outcome$source_conte3 = outcome.source_context_info) === null || _outcome$source_conte3 === void 0 ? void 0 : _outcome$source_conte3.context_type) {
          case 'course':
            outcome.decorator = HIDE;
            break;
          case 'account':
            outcome.decorator = NOT_IN_COURSE;
            break;
        }
      }
    }
  });

  // Now that the outcomes are populated with the decorator, sort by title then sort by decorator.
  // The various components will need to filter out those that are hidden, but they need to be
  // returned and stored in the redux store to prevent them from getting unaligned when the
  // alignment set is mutated.
  alignmentSet.outcomes = outcomes.sort(function (a, b) {
    var titleA = a && a.title || 'ZZZZZZZZZZZZ'; // treat null as really large
    var titleB = b && b.title || 'ZZZZZZZZZZZZ'; // treat null as really large
    return titleA.localeCompare(titleB);
  }).sort(byDecorator);
  return alignmentSet;
};
/* eslint-enable no-param-reassign */
var OutcomesService = /*#__PURE__*/function () {
  function OutcomesService() {
    _classCallCheck(this, OutcomesService);
  }
  return _createClass(OutcomesService, [{
    key: "get",
    value: function get(host, jwt, path) {
      return fetch(host + path, {
        headers: {
          Authorization: jwt
        }
      });
    }
  }, {
    key: "post",
    value: function post(host, jwt, path, body) {
      return fetch(host + path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: jwt
        },
        body: JSON.stringify(body)
      });
    }
  }, {
    key: "getContext",
    value: function getContext(host, jwt, contextUuid) {
      var params = '?includes[]=outcome_proficiency&includes[]=outcome_calculation_method';
      return this.get(host, jwt, "/api/contexts/".concat(contextUuid).concat(params)).then(checkResponse).then(toJson);
    }
  }, {
    key: "loadOutcomes",
    value: function loadOutcomes(host, jwt) {
      var contextUuid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
      var roots = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      var params = "?excludes[]=scoring_method&depth=".concat(OUTCOME_QUERY_DEPTH);
      if (contextUuid) {
        params += "&".concat(queryString.stringify({
          context_uuid: contextUuid
        }));
      }
      params += '&includes[]=friendly_description&includes[]=source_context_info';
      if (roots) {
        params += "&".concat(queryString.stringify({
          roots: roots
        }, {
          arrayFormat: 'bracket'
        }));
      }
      return this.get(host, jwt, "/api/outcomes/tree".concat(params)).then(checkResponse).then(toJson).then(function (json) {
        return json.outcome_tree || json;
      });
    }
  }, {
    key: "getOutcome",
    value: function getOutcome(host, jwt, id, contextUuid) {
      var params = '?includes[]=friendly_description';
      if (contextUuid) {
        params += "&".concat(queryString.stringify({
          context_uuid: contextUuid
        }));
      }
      return this.get(host, jwt, "/api/outcomes/".concat(id).concat(params)).then(checkResponse).then(toJson).then(function (json) {
        return json;
      });
    }
  }, {
    key: "getAlignments",
    value: function getAlignments(host, jwt, alignmentSetId, contextUuid, launchContext, isLaunchingFromRootAccount) {
      if (!alignmentSetId) {
        return Promise.resolve([]);
      }
      var params = 'includes[]=outcomes&includes[]=friendly_description&includes[]=source_context_info';
      if (contextUuid) {
        params += "&context_uuid=".concat(contextUuid);
      }
      if (launchContext) {
        params += "&launch_context=".concat(launchContext);
      }
      return this.get(host, jwt, "/api/alignment_sets/".concat(alignmentSetId, "?").concat(params)).then(checkResponse).then(toJson).then(function (json) {
        return decorateAlignments(json.alignment_set || json, launchContext, isLaunchingFromRootAccount);
      });
    }
  }, {
    key: "getArtifact",
    value: function getArtifact(host, jwt, artifactType, artifactId) {
      var params = {
        artifact_type: artifactType,
        artifact_id: artifactId,
        includes: 'friendly_description'
      };
      return this.get(host, jwt, "/api/artifact?".concat(queryString.stringify(params))).then(checkResponse).then(toJson).then(function (json) {
        return json.alignment_set || json;
      });
    }
  }, {
    key: "upsertArtifact",
    value: function upsertArtifact(host, jwt, artifactType, artifactId, contextUuid, outcomeIds) {
      var params = {
        artifact_id: artifactId,
        artifact_type: artifactType,
        context_uuid: contextUuid,
        outcome_ids: outcomeIds
      };
      return this.post(host, jwt, '/api/artifacts', params).then(checkResponse).then(function (response) {
        if (!outcomeIds.length) {
          return Promise.resolve({
            guid: null
          });
        }
        return toJson(response);
      }).then(function (json) {
        return json.alignment_set || json;
      });
    }
  }, {
    key: "createAlignmentSet",
    value: function createAlignmentSet(host, jwt, outcomeIds, launchContext, isLaunchingFromRootAccount) {
      if (!outcomeIds.length) {
        return Promise.resolve({
          guid: null
        });
      }
      var params = {
        outcome_ids: outcomeIds,
        includes: ['outcomes', 'source_context_info']
      };
      if (launchContext) {
        params.launch_context = launchContext;
      }
      return this.post(host, jwt, '/api/alignment_sets', params).then(checkResponse).then(toJson).then(function (json) {
        return decorateAlignments(json.alignment_set || json, launchContext, isLaunchingFromRootAccount);
      });
    }
  }, {
    key: "getOutcomeRollups",
    value: function getOutcomeRollups(host, jwt, artifactType, artifactId) {
      var params = {
        artifact_type: artifactType,
        artifact_id: artifactId
      };
      return this.get(host, jwt, "/api/outcome_rollups?".concat(queryString.stringify(params))).then(checkResponse).then(toJson).then(function (json) {
        return json.outcome_rollups || json;
      });
    }
  }, {
    key: "getOutcomeResults",
    value: function getOutcomeResults(host, jwt, artifactType, artifactId, outcomeId, userList) {
      var params = {
        artifact_type: artifactType,
        artifact_id: artifactId,
        outcome_id: outcomeId,
        user_uuid_list: userList.join(',')
      };
      return this.get(host, jwt, "/api/authoritative_results?".concat(queryString.stringify(params))).then(checkResponse).then(toJson).then(function (json) {
        return json.results;
      });
    }
  }, {
    key: "getUsers",
    value: function getUsers(host, jwt, artifactType, artifactId, page) {
      var params = {
        page: page,
        artifact_type: artifactType,
        artifact_id: artifactId
      };
      var response;
      return this.get(host, jwt, "/api/users?".concat(queryString.stringify(params))).then(checkResponse).then(function (resp) {
        return (response = resp).json();
      }) // eslint-disable-line no-return-assign
      .then(function (json) {
        return {
          users: json,
          page: page,
          total: parseInt(response.headers.get('total'), 10),
          perPage: parseInt(response.headers.get('per-page'), 10)
        };
      });
    }
  }, {
    key: "getIndividualResults",
    value: function getIndividualResults(host, jwt, artifactType, artifactId, userUuid) {
      var params = {
        artifact_type: artifactType,
        artifact_id: artifactId,
        user_uuid: userUuid,
        includes: ['outcomes', 'outcome_rollups']
      };
      return this.get(host, jwt, "/api/individual_results?".concat(queryString.stringify(params, {
        arrayFormat: 'bracket'
      }))).then(checkResponse).then(toJson).then(function (json) {
        return json.results;
      });
    }
  }, {
    key: "getFeatures",
    value: function getFeatures(host, jwt) {
      return this.get(host, jwt, '/api/features').then(checkResponse).then(toJson);
    }
  }, {
    key: "listOutcomes",
    value: function listOutcomes(host, jwt, page) {
      var contextUuid = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      var artifactId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
      var artifactType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
      var params = {
        per_page: 10,
        page: page,
        includes: ['scoring_method', 'friendly_description', 'source_context_info']
      };
      if (contextUuid) {
        params['context_uuid'] = contextUuid;
      }
      if (artifactId) {
        params['artifact_id'] = artifactId;
      }
      if (artifactType) {
        params['artifact_type'] = artifactType;
      }
      var total = 0;
      return this.get(host, jwt, "/api/outcomes/list?".concat(queryString.stringify(params, {
        arrayFormat: 'bracket'
      }))).then(checkResponse).then(function (response) {
        total = getTotal(response);
        return response;
      }).then(toJson).then(function (json) {
        return {
          outcomes: json,
          total: total
        };
      });
    }
  }, {
    key: "getSearchResults",
    value: function getSearchResults(host, jwt, text, page) {
      var contextUuid = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : '';
      var params = {
        text: text,
        page: page,
        includes: ['scoring_method', 'friendly_description', 'source_context_info']
      };
      if (contextUuid) {
        params['context_uuid'] = contextUuid;
      }
      var total = 0;
      return this.get(host, jwt, "/api/outcomes/search?".concat(queryString.stringify(params, {
        arrayFormat: 'bracket'
      }))).then(checkResponse).then(function (response) {
        total = getTotal(response);
        return response;
      }).then(toJson).then(function (json) {
        return Promise.resolve(_objectSpread(_objectSpread({}, json), {}, {
          total: total
        }));
      });
    }
  }]);
}();
export default OutcomesService;